/* ============================================================
   Countdown Timer (collection banners) — count-timer.js
   <count-timer data-end-iso="..." data-end="..." data-daily-reset="true">
   Thin wrapper around the shared window.theme.CountdownEngine
   (assets/countdown-engine.js, loaded first) — see that file for the
   parsing/ticking/daily-reset logic itself. This file only wires the
   engine to this element's lifecycle.
   ============================================================ */
class CountTimer extends HTMLElement {
  connectedCallback() {
    this._engine = new window.theme.CountdownEngine(this);
    this._engine.start();
  }

  disconnectedCallback() {
    if (this._engine) this._engine.destroy();
  }
}
customElements.define('count-timer', CountTimer);
